export default __webpack_public_path__ + "static/media/gm-net-girl.ad9c532d.png";